var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 11.8337C2.7776 11.8337 0.166016 9.22208 0.166016 6.00033C0.166016 2.77858 2.7776 0.166992 5.99935 0.166992C9.2211 0.166992 11.8327 2.77858 11.8327 6.00033C11.8327 9.22208 9.2211 11.8337 5.99935 11.8337ZM5.99935 10.667C7.23703 10.667 8.42401 10.1753 9.29918 9.30016C10.1744 8.42499 10.666 7.238 10.666 6.00033C10.666 4.76265 10.1744 3.57566 9.29918 2.70049C8.42401 1.82532 7.23703 1.33366 5.99935 1.33366C4.76167 1.33366 3.57469 1.82532 2.69952 2.70049C1.82435 3.57566 1.33268 4.76265 1.33268 6.00033C1.33268 7.238 1.82435 8.42499 2.69952 9.30016C3.57469 10.1753 4.76167 10.667 5.99935 10.667ZM5.41777 8.33366L2.94268 5.85858L3.76752 5.03374L5.41777 6.68399L8.7171 3.38408L9.54252 4.20891L5.41777 8.33366Z",
    fill: "#10A515"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOutline);
export default __webpack_public_path__ + "static/media/success-outline.398f95a2.svg";
export { ForwardRef as ReactComponent };